import { Paper } from '@mantine/core';
import { useState } from 'react';

import { useGetVacancyCandidates } from '@entities/vacancy';
import { useFeatureFlag } from '@packages/feature-flags/react';

import { CandidatePickDrawer } from './components/drawer/candidate-pick-drawer';
import { PositiveCandidates } from './components/PositiveCandidates';
import { RecommendedCandidates } from './components/RecommendedCandidates';
import {
  PENDING_CANDIDATES_PARAMS,
  POSITIVE_CANDIDATES_PARAMS,
} from './constants';

//
//

type SelectedCandidatesProps = {
  vacancyId: number;
  vacancyName: string;
  vacantPlaces: number;
  currency: string;
  paymentPeriod: string;
};

export const SelectedCandidates = ({
  vacancyId,
  vacancyName,
  vacantPlaces,
  currency,
  paymentPeriod,
}: SelectedCandidatesProps) => {
  const [pickDrawerOpened, setPickDrawerOpened] = useState(false);
  const candidatePickingEnabled = useFeatureFlag('candidatePicking');
  const positiveCandidatesQuery = useGetVacancyCandidates(
    vacancyId,
    POSITIVE_CANDIDATES_PARAMS
  );
  const pendingCandidatesQuery = useGetVacancyCandidates(
    vacancyId,
    PENDING_CANDIDATES_PARAMS
  );
  const recommendedCandidatesCount =
    pendingCandidatesQuery.data?.pagination?.total ?? 0;
  const showRecommendedCandidates =
    pendingCandidatesQuery.isLoading ||
    pendingCandidatesQuery.isError ||
    recommendedCandidatesCount > 0;

  const handlePickClick = () => {
    setPickDrawerOpened(true);
  };

  return (
    <>
      <Paper
        radius={16}
        shadow='md'
        bd='1px solid var(--mantine-color-primary-0)'
        maw={418}
        miw={{ base: 'auto', sm: '25.5rem' }}
        w='100%'
        style={{ overflow: 'hidden' }}
      >
        {showRecommendedCandidates && (
          <RecommendedCandidates
            candidatesCount={recommendedCandidatesCount}
            isError={pendingCandidatesQuery.isError}
            isLoading={pendingCandidatesQuery.isLoading}
            onPick={
              candidatePickingEnabled &&
              !pendingCandidatesQuery.isLoading &&
              !pendingCandidatesQuery.isError
                ? handlePickClick
                : undefined
            }
          />
        )}

        <PositiveCandidates
          candidates={positiveCandidatesQuery.data?.data ?? []}
          candidatesCount={positiveCandidatesQuery.data?.pagination?.total ?? 0}
          isError={positiveCandidatesQuery.isError}
          isLoading={positiveCandidatesQuery.isLoading}
          showEmptyMessage={
            !pendingCandidatesQuery.isLoading &&
            !pendingCandidatesQuery.isError &&
            recommendedCandidatesCount === 0
          }
          vacancyId={vacancyId}
        />
      </Paper>

      <CandidatePickDrawer
        vacancyId={vacancyId}
        vacancyTitle={vacancyName}
        vacantPlaces={vacantPlaces}
        currency={currency}
        paymentPeriod={paymentPeriod}
        opened={pickDrawerOpened}
        onClose={() => setPickDrawerOpened(false)}
      />
    </>
  );
};
